/**
 * Community reviews — native PDP module
 */
(function () {
  'use strict';
  var P = '/apps/purp-delivery/community-product-reviews', MX = 2000, MN = 20;
  var scriptEl = document.currentScript;
  var purpMark = scriptEl ? scriptEl.getAttribute('data-purp-mark') || '' : '';
  var el, listEl, navEl, writeBtn, ctaSlot, snapEl, filtersEl, overlay, form;
  var pid, handle, uid, rgk, nextCursor = null, more = false, busy = false, my = null;
  var rating = 0, buyAgain = null, currentFilter = 'all', currentSort = 'recent', allReviews = [];
  var photos = [], photoUploading = 0, MAX_PHOTOS = 3, MAX_PHOTO_SIZE = 5 * 1024 * 1024;
  var submitAttemptKey = '', deleteAttemptKey = '';

  function init() {
    el = document.getElementById('pr');
    if (!el) return;
    pid = el.dataset.pid; handle = el.dataset.handle; uid = !!el.dataset.uid;
    listEl = document.getElementById('pr-list');
    navEl = document.getElementById('pr-nav');
    writeBtn = document.getElementById('pr-write');
    ctaSlot = document.getElementById('pr-cta-slot');
    snapEl = document.getElementById('pr-snap');
    filtersEl = document.getElementById('pr-filters');
    overlay = document.getElementById('pr-ov');
    form = document.getElementById('pr-form');

    if (writeBtn) writeBtn.addEventListener('click', function () { openModal(false); });
    if (overlay) overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
    var xBtn = document.getElementById('pr-x');
    if (xBtn) xBtn.addEventListener('click', closeModal);

    // Carousel nav
    var prevBtn = document.getElementById('pr-prev');
    var nextBtn = document.getElementById('pr-next');
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollCarousel(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollCarousel(1); });

    initStars(); initChips(); initBuy(); initNav();
    if (form) {
      form.addEventListener('submit', submit);
      form.addEventListener('input', invalidateSubmitAttempt);
      form.addEventListener('change', invalidateSubmitAttempt);
    }
    var bodyIn = form ? form.querySelector('#pr-b') : null;
    if (bodyIn) bodyIn.addEventListener('input', function () {
      var cc = document.getElementById('pr-cc');
      if (cc) cc.textContent = bodyIn.value.length + ' / ' + MX;
    });

    // photo upload
    initPhotoUpload();

    // filters — event delegation on parent
    if (filtersEl) filtersEl.addEventListener('click', function (e) {
      var b = e.target.closest('.pr-filter-btn');
      if (!b) return;
      filtersEl.querySelectorAll('.pr-filter-btn').forEach(function (x) { x.classList.remove('active'); });
      b.classList.add('active');
      var f = b.dataset.filter;
      if (f === 'verified') { currentFilter = 'verified'; currentSort = 'recent'; }
      else if (f === 'highest') { currentFilter = 'all'; currentSort = 'highest'; }
      else { currentFilter = 'all'; currentSort = 'recent'; }
      nextCursor = null;
      allReviews = [];
      if (listEl) listEl.style.opacity = '0.4';
      loadReviews(false);
    });

    fetchCtx();
  }

  // ── context ────────────────────────────────────────────────
  function fetchCtx() {
    var q = [];
    if (pid) q.push('shopifyProductId=' + enc(pid));
    if (handle) q.push('handle=' + enc(handle));
    fetch(P + '/review-context?' + q.join('&') + '&_t=' + Date.now()).then(ok).then(function (d) {
      rgk = d.reviewGroupKey;
      if (!rgk) {
        listEl.innerHTML = '<div class="pr-empty">Reviews are being enabled for this product. Please check back soon.</div>';
        if (writeBtn) writeBtn.style.display = 'none';
        return;
      }
      if (writeBtn) writeBtn.style.display = '';
      if (d.aggregate) renderHeader(d.aggregate);
      loadReviews(false);
    }).catch(function () { listEl.innerHTML = '<div class="pr-empty">Unable to load reviews.</div>'; });
  }

  // ── reviews ────────────────────────────────────────────────
  function loadReviews(isLoadMore) {
    if (!rgk) return;
    var url = P + '/get-reviews?reviewGroupKey=' + enc(rgk) + '&limit=20' +
      '&filter=' + enc(currentFilter) +
      '&sort=' + enc(currentSort) +
      '&_t=' + Date.now();

    if (isLoadMore && nextCursor) {
      if (typeof nextCursor === 'object') {
        url += '&cursor=' + enc(nextCursor.cursor) + '&cursorRating=' + nextCursor.cursorRating;
      } else {
        url += '&cursor=' + enc(nextCursor);
      }
    }

    fetch(url).then(ok).then(function (d) {
      my = d.myReview || null;
      if (!isLoadMore) allReviews = [];
      allReviews = allReviews.concat(d.reviews || []);
      more = d.hasMore;
      nextCursor = d.nextCursor || null;
      renderList();
      updateCta();
      if (filtersEl && allReviews.length > 0) filtersEl.style.display = '';
    }).catch(function () { if (!isLoadMore) listEl.innerHTML = '<div class="pr-empty">Unable to load reviews.</div>'; });
  }

  function renderList() {
    listEl.innerHTML = '';
    listEl.style.opacity = '1';
    if (!allReviews.length) { listEl.innerHTML = '<div class="pr-empty">No reviews match this filter.</div>'; }
    else allReviews.forEach(function (r, i) { listEl.appendChild(card(r, i)); });

    if (navEl) navEl.style.display = allReviews.length > 1 ? '' : 'none';
    if (listEl) listEl.scrollLeft = 0;

    var statusEl = document.getElementById('pr-filter-status');
    if (statusEl) {
      var n = allReviews.length;
      var label = currentFilter === 'verified' ? n + ' PURP Verified review' + (n !== 1 ? 's' : '')
        : currentSort === 'highest' ? n + ' review' + (n !== 1 ? 's' : '') + ' · highest rated'
        : n + ' review' + (n !== 1 ? 's' : '');
      statusEl.textContent = label;
    }
  }

  function scrollCarousel(dir) {
    if (!listEl) return;
    var cardW = listEl.querySelector('.pr-card');
    var scrollAmt = cardW ? cardW.offsetWidth + 12 : 340;
    listEl.scrollBy({ left: dir * scrollAmt, behavior: 'smooth' });
  }

  function updateCta() {
    if (!ctaSlot || !uid) return;
    if (my) {
      ctaSlot.innerHTML = '<button class="pr-cta-secondary" id="pr-edit-cta">Edit your review</button>';
      document.getElementById('pr-edit-cta').addEventListener('click', function () { openModal(true); });
    }
  }

  // ── header + snapshot ──────────────────────────────────────
  function renderHeader(a) {
    var sum = document.getElementById('pr-summary');
    if (sum) {
      sum.innerHTML = '<span class="pr-stars">' + stars(Math.round(a.avgRating)) + '</span> ' +
        '<strong>' + (a.avgRating || 0).toFixed(1) + '</strong> · ' +
        (a.reviewCount || 0) + ' review' + (a.reviewCount !== 1 ? 's' : '');
    }
    if (a.reviewCount > 0) renderSnap(a);
  }

  function renderSnap(a) {
    var parts = [], ct = a.reviewCount || 1;
    var topFx = topN(a.effectCounts, 3);
    if (topFx.length) parts.push('<span class="pr-snap-item"><span class="pr-snap-label">Effects</span> <strong>' + topFx.map(function (e) { return lbl(e[0]); }).join(', ') + '</strong></span>');
    var topFl = topN(a.flavorCounts, 3);
    if (topFl.length) parts.push('<span class="pr-snap-item"><span class="pr-snap-label">Flavor</span> <strong>' + topFl.map(function (f) { return lbl(f[0]); }).join(', ') + '</strong></span>');
    var topBf = topN(a.bestForCounts, 2);
    if (topBf.length) parts.push('<span class="pr-snap-item"><span class="pr-snap-label">Best for</span> <strong>' + topBf.map(function (b) { return lbl(b[0]); }).join(', ') + '</strong></span>');
    if (a.wouldBuyAgainCount > 0) parts.push('<span class="pr-snap-item"><strong>' + Math.round((a.wouldBuyAgainCount / ct) * 100) + '%</strong> would buy again</span>');
    if (parts.length) { snapEl.innerHTML = parts.join(''); snapEl.style.display = ''; }
  }

  // ── card ───────────────────────────────────────────────────
  function card(r, idx) {
    var c = document.createElement('div'); c.className = 'pr-card'; c.style.cursor = 'pointer';
    var isOwn = my && my.id === r.id;
    var dt = r.createdAt ? new Date(r.createdAt).toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: 'numeric' }) : '';
    var edited = r.isEdited ? '<span class="pr-card-edited">edited</span>' : '';

    var tags = '';
    if ((r.effects && r.effects.length) || (r.flavorNotes && r.flavorNotes.length) || (r.bestFor && r.bestFor.length) || r.wouldBuyAgain === true) {
      tags = '<div class="pr-tags">';
      if (r.effects && r.effects.length) tags += tagGroup('Effects', r.effects);
      if (r.flavorNotes && r.flavorNotes.length) tags += tagGroup('Flavor', r.flavorNotes);
      if (r.bestFor && r.bestFor.length) tags += tagGroup('Best for', r.bestFor);
      if (r.wouldBuyAgain === true) tags += '<div class="pr-tag-group"><span class="pr-tag rc-would-buy-again">Would buy again</span></div>';
      tags += '</div>';
    }

    var own = '';
    if (isOwn && uid) {
      own = '<div class="pr-own"><button data-a="edit">Edit</button><button class="pr-del" data-a="del">Delete</button></div>';
    }

    c.innerHTML =
      '<div class="pr-card-meta"><div class="pr-card-who"><span class="pr-card-name">' + esc(r.authorFirstName) + '</span>' +
      (r.verified ? verifiedBadge() : '') +
      '</div><span class="pr-card-date">' + dt + ' ' + edited + '</span></div>' +
      '<div class="pr-card-stars">' + stars(r.rating) + '</div>' +
      (r.title ? '<p class="pr-card-title">' + esc(r.title) + '</p>' : '') +
      '<p class="pr-card-body">' + esc(r.body) + '</p>' +
      '<button type="button" class="pr-read-toggle">Read more</button>' +
      photoThumbs(r.photos) +
      tags + own;

    // "Read more" toggle — show only when body is actually clamped
    var bodyEl = c.querySelector('.pr-card-body');
    var toggleEl = c.querySelector('.pr-read-toggle');
    if (bodyEl && toggleEl) {
      requestAnimationFrame(function () {
        if (bodyEl.scrollHeight > bodyEl.clientHeight + 1) {
          toggleEl.style.display = 'block';
        }
      });
      toggleEl.addEventListener('click', function () {
        var exp = bodyEl.classList.toggle('expanded');
        toggleEl.textContent = exp ? 'Read less' : 'Read more';
      });
    }

    // Open fullscreen carousel on card click (not on buttons)
    (function (cardIdx) {
      c.addEventListener('click', function (e) {
        if (e.target.closest('button, a, .pr-own')) return;
        openFs(cardIdx);
      });
    })(idx);

    if (isOwn && uid) {
      var eb = c.querySelector('[data-a="edit"]');
      var db = c.querySelector('[data-a="del"]');
      if (eb) eb.addEventListener('click', function () { openModal(true); });
      if (db) db.addEventListener('click', doDelete);
    }
    return c;
  }

  function tagGroup(label, items) {
    var h = '<div class="pr-tag-group"><span class="pr-tag-label">' + label + '</span>';
    items.forEach(function (t) { h += '<span class="pr-tag rc-' + t + '">' + lbl(t) + '</span>'; });
    return h + '</div>';
  }

  // ── modal — uses shared SmokeysDialog helper ──────────────
  var pdpDialog = null;

  function ensureDialog() {
    if (pdpDialog) return pdpDialog;
    if (overlay && window.SmokeysDialog) {
      pdpDialog = window.SmokeysDialog.create({
        overlay: overlay,
        container: overlay.querySelector('.pr-modal'),
        openClass: 'open',
      });
    }
    return pdpDialog;
  }

  function openModal(edit) {
    if (!overlay) return;
    var dlg = ensureDialog();
    if (!dlg) return;
    submitAttemptKey = '';
    document.getElementById('pr-modal-title').textContent = edit ? 'Edit your review' : 'Share your review';
    if (edit && my) { prefill(); } else { resetForm(); }
    goStep(1);
    dlg.open();
  }

  function closeModal() {
    var dlg = ensureDialog();
    if (dlg) dlg.close();
  }

  function prefill() {
    setRating(my.rating);
    setChips('effects', my.effects || []);
    setChips('flavorNotes', my.flavorNotes || []);
    setChips('bestFor', my.bestFor || []);
    setBuy(my.wouldBuyAgain);
    var ti = form.querySelector('#pr-t'); if (ti) ti.value = my.title || '';
    var bi = form.querySelector('#pr-b'); if (bi) { bi.value = my.body || ''; bi.dispatchEvent(new Event('input')); }
    photos = (my.photos || []).map(function (p, index) {
      return {
        slot: Number.isInteger(p.slot) ? p.slot : index,
        uploadedAssetId: p.uploadedAssetId || '',
        assetId: p.assetId || '',
        photoUrl: p.photoUrl || '',
        thumbUrl: p.thumbUrl || '',
      };
    });
    photoUploading = 0;
    renderPhotoSlots();
  }

  // ── stars ──────────────────────────────────────────────────
  function initStars() {
    var p = document.getElementById('pr-stars'); if (!p) return;
    p.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () { setRating(+b.dataset.v); });
    });
  }
  function setRating(v) {
    invalidateSubmitAttempt();
    rating = v;
    var p = document.getElementById('pr-stars'); if (!p) return;
    p.querySelectorAll('button').forEach(function (b) { b.classList.toggle('on', +b.dataset.v <= v); });
  }

  // ── chips ──────────────────────────────────────────────────
  function initChips() {
    document.querySelectorAll('.pr-pick-chips').forEach(function (g) {
      g.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () { b.classList.toggle('on'); invalidateSubmitAttempt(); });
      });
    });
  }
  function getChips(f) {
    var g = document.querySelector('.pr-pick-chips[data-field="' + f + '"]'); if (!g) return [];
    return Array.from(g.querySelectorAll('button.on')).map(function (b) { return b.dataset.val; });
  }
  function setChips(f, vals) {
    var g = document.querySelector('.pr-pick-chips[data-field="' + f + '"]'); if (!g) return;
    g.querySelectorAll('button').forEach(function (b) { b.classList.toggle('on', vals.indexOf(b.dataset.val) !== -1); });
  }

  // ── buy again ──────────────────────────────────────────────
  function initBuy() {
    var t = document.getElementById('pr-buy'); if (!t) return;
    t.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.dataset.val === 'true';
        setBuy(buyAgain === v ? null : v);
      });
    });
  }
  function setBuy(v) {
    invalidateSubmitAttempt();
    buyAgain = v;
    var t = document.getElementById('pr-buy'); if (!t) return;
    t.querySelectorAll('button').forEach(function (b) {
      b.classList.remove('on-yes', 'on-no');
      if (v === true && b.dataset.val === 'true') b.classList.add('on-yes');
      if (v === false && b.dataset.val === 'false') b.classList.add('on-no');
    });
  }

  // ── nav ────────────────────────────────────────────────────
  function initNav() {
    on('pr-n1', function () { if (!rating) { msg('Pick a rating first', 'err'); return; } goStep(2); });
    on('pr-b2', function () { goStep(1); });
    on('pr-n2', function () { goStep(3); });
    on('pr-b3', function () { goStep(2); });
  }
  function goStep(n) {
    document.querySelectorAll('.pr-step').forEach(function (s) { s.classList.toggle('active', +s.dataset.step === n); });
  }

  // ── submit ─────────────────────────────────────────────────
  function submit(e) {
    e.preventDefault(); if (busy || !rgk) return; clrMsg();
    var tv = (form.querySelector('#pr-t') || {}).value || '';
    tv = tv.trim();
    if (tv.length < 2) { msg('Give your review a short title.', 'err'); return; }
    var bv = (form.querySelector('#pr-b') || {}).value || '';
    bv = bv.trim();
    if (bv.length < MN) { msg('Review must be at least ' + MN + ' characters.', 'err'); return; }
    if (photoUploading > 0) { msg('Photos still uploading\u2026', 'err'); return; }
    var submittedPhotos = photosForSubmit(photos);
    if (submittedPhotos.length !== photos.length) {
      msg('Please remove and re-add any photo that has not finished securely uploading.', 'err');
      return;
    }
    var attemptKey = submitAttemptKey || newIdempotencyKey();
    if (!attemptKey) { msg('Secure submission is unavailable in this browser.', 'err'); return; }
    submitAttemptKey = attemptKey;
    busy = true;
    var sub = document.getElementById('pr-sub');
    if (sub) { sub.disabled = true; sub.textContent = 'Submitting\u2026'; }

    fetch(P + '/submit-review', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Idempotency-Key': attemptKey },
      body: JSON.stringify({
        idempotencyKey: attemptKey,
        rating: rating,
        title: (form.querySelector('#pr-t') || {}).value || '',
        body: bv,
        effects: getChips('effects'),
        flavorNotes: getChips('flavorNotes'),
        bestFor: getChips('bestFor'),
        wouldBuyAgain: buyAgain,
        photos: submittedPhotos,
        shopifyProductId: pid,
        shopifyProductHandle: handle,
      }),
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (r) {
        if (r.ok) {
          submitAttemptKey = '';
          msg(r.d.isEdit ? 'Review updated.' : 'Thanks for your review!', 'ok');
          setTimeout(function () { closeModal(); fetchCtx(); loadReviews(false); }, 1000);
        } else { msg(r.d.error || 'Failed to submit.', 'err'); }
      })
      .catch(function () { msg('Network error.', 'err'); })
      .finally(function () { busy = false; if (sub) { sub.disabled = false; sub.textContent = 'Submit'; } });
  }

  // ── PURP confirm modal ─────────────────────────────────────
  function prConfirm(opts) {
    return new Promise(function (resolve) {
      var ov = document.createElement('div');
      ov.className = 'pr-confirm-overlay';
      ov.innerHTML =
        '<div class="pr-confirm">' +
          '<div class="pr-confirm-header">' + esc(opts.title || 'Confirm') + '</div>' +
          '<div class="pr-confirm-body">' + esc(opts.message || '') + '</div>' +
          '<div class="pr-confirm-actions">' +
            '<button class="pr-confirm-btn pr-confirm-cancel" type="button">Cancel</button>' +
            '<button class="pr-confirm-btn pr-confirm-ok" type="button">' + esc(opts.confirmLabel || 'Confirm') + '</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(ov);
      function cleanup() { ov.remove(); }
      ov.querySelector('.pr-confirm-cancel').addEventListener('click', function () { cleanup(); resolve(false); });
      ov.querySelector('.pr-confirm-ok').addEventListener('click', function () { cleanup(); resolve(true); });
      ov.addEventListener('click', function (e) { if (e.target === ov) { cleanup(); resolve(false); } });
    });
  }

  // ── delete ─────────────────────────────────────────────────
  function doDelete() {
    if (!rgk) return;
    prConfirm({ title: 'Delete Review', message: 'Are you sure you want to delete your review? Your $1 Smoke Credit will be reversed.', confirmLabel: 'Delete' }).then(function (yes) {
      if (!yes) return;
      var attemptKey = deleteAttemptKey || newIdempotencyKey();
      if (!attemptKey) { prConfirm({ title: 'Error', message: 'Secure deletion is unavailable in this browser.', confirmLabel: 'OK' }); return; }
      deleteAttemptKey = attemptKey;
      fetch(P + '/delete-review', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Idempotency-Key': attemptKey }, body: JSON.stringify({ idempotencyKey: attemptKey, reviewGroupKey: rgk }) })
        .then(ok).then(function () { deleteAttemptKey = ''; my = null; setTimeout(function () { fetchCtx(); loadReviews(false); }, 800); })
        .catch(function () { prConfirm({ title: 'Error', message: 'Failed to delete review. Please try again.', confirmLabel: 'OK' }); });
    });
  }

  // ── reset ──────────────────────────────────────────────────
  function resetForm() {
    submitAttemptKey = '';
    setRating(0); setBuy(null);
    document.querySelectorAll('.pr-pick-chips button').forEach(function (b) { b.classList.remove('on'); });
    if (form) form.reset();
    photos = []; photoUploading = 0; renderPhotoSlots(); photoStatus('');
  }

  // ── util ───────────────────────────────────────────────────
  var _slogo = 'https://cdn.shopify.com/s/files/1/0913/0967/0716/files/Reviews_Stars.png?v=1774378184';
  function stars(n) { var s = ''; for (var i = 1; i <= 5; i++) s += '<img src="' + _slogo + '" class="pr-s-icon' + (i <= n ? '' : ' pr-s-off') + '" width="14" height="14" alt="">'; return s; }
  function lbl(s) { return (s || '').replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); }); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }
  function enc(s) { return encodeURIComponent(s); }
  function ok(r) { if (!r.ok) throw new Error(r.status); return r.json(); }
  function invalidateSubmitAttempt() { submitAttemptKey = ''; }
  function newIdempotencyKey() {
    var cryptoApi = window.crypto || window.msCrypto;
    if (!cryptoApi) return '';
    if (typeof cryptoApi.randomUUID === 'function') return cryptoApi.randomUUID();
    if (typeof cryptoApi.getRandomValues !== 'function') return '';
    var bytes = new Uint8Array(16);
    cryptoApi.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    var hex = Array.from(bytes).map(function (value) { return value.toString(16).padStart(2, '0'); }).join('');
    return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20);
  }
  function verifiedBadge() {
    var mark = purpMark ? '<img src="' + esc(purpMark) + '" width="12" height="12" alt="">' : '';
    return '<span class="pr-badge-verified">' + mark + 'PURP Verified</span>';
  }
  function on(id, fn) { var e = document.getElementById(id); if (e) e.addEventListener('click', fn); }
  function msg(t, type) { var c = document.getElementById('pr-msg'); if (c) c.innerHTML = '<div class="pr-msg pr-msg-' + type + '">' + esc(t) + '</div>'; }
  function clrMsg() { var c = document.getElementById('pr-msg'); if (c) c.innerHTML = ''; }
  function topN(o, n) { return Object.entries(o || {}).sort(function (a, b) { return b[1] - a[1]; }).slice(0, n); }
  function photoThumbs(arr) {
    if (!arr || !arr.length) return '';
    var h = '<div class="pr-card-photos">';
    arr.forEach(function (p) { h += '<img src="' + esc(p.thumbUrl || p.photoUrl) + '" class="pr-card-photo" loading="lazy" alt="Review photo">'; });
    return h + '</div>';
  }
  function photosFull(arr) {
    if (!arr || !arr.length) return '';
    var h = '<div class="pr-fs-photos">';
    arr.forEach(function (p) { h += '<img src="' + esc(p.photoUrl) + '" class="pr-fs-photo" loading="lazy" alt="Review photo">'; });
    return h + '</div>';
  }

  // ── photo upload ───────────────────────────────────────────
  function initPhotoUpload() {
    var input = document.getElementById('pr-photo-input');
    if (!input) return;
    input.addEventListener('change', function () {
      var files = Array.from(input.files || []);
      input.value = '';
      files.forEach(function (f) { uploadPhoto(f); });
    });
  }

  function uploadPhoto(file) {
    if (photos.length >= MAX_PHOTOS) { photoStatus('Maximum ' + MAX_PHOTOS + ' photos'); return; }
    if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) { photoStatus('JPEG, PNG, or WebP only'); return; }
    if (file.size > MAX_PHOTO_SIZE) { photoStatus('Photo must be under 5MB'); return; }

    var slot = nextPhotoSlot(photos, MAX_PHOTOS);
    if (slot < 0) { photoStatus('Maximum ' + MAX_PHOTOS + ' photos'); return; }
    var uploadAttemptKey = newIdempotencyKey();
    if (!uploadAttemptKey) { photoStatus('Secure photo upload is unavailable in this browser.'); return; }
    var placeholder = { slot: slot, uploading: true, localUrl: URL.createObjectURL(file), idempotencyKey: uploadAttemptKey };
    invalidateSubmitAttempt();
    photos.push(placeholder);
    renderPhotoSlots();
    photoUploading++;
    photoStatus('Uploading...');

    var upload = new FormData();
    upload.append('idempotencyKey', uploadAttemptKey);
    upload.append('file', file, file.name || 'review-photo');
    upload.append('slot', String(slot));
    if (pid) upload.append('shopifyProductId', String(pid));
    if (handle) upload.append('shopifyProductHandle', String(handle));

    fetch(P + '/upload-review-photo', { method: 'POST', headers: { 'Idempotency-Key': uploadAttemptKey }, body: upload })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (r) {
        photoUploading--;
        var photoIndex = photos.indexOf(placeholder);
        var uploaded = r.ok && r.d.ok ? uploadedPhoto(r.d, slot) : null;
        if (uploaded && photoIndex !== -1) {
          if (placeholder.localUrl) URL.revokeObjectURL(placeholder.localUrl);
          photos[photoIndex] = uploaded;
          photoStatus('');
        } else {
          if (placeholder.localUrl) URL.revokeObjectURL(placeholder.localUrl);
          if (photoIndex !== -1) photos.splice(photoIndex, 1);
          photoStatus(r.d.error || 'Secure photo upload failed');
        }
        renderPhotoSlots();
      })
      .catch(function () {
        photoUploading--;
        var photoIndex = photos.indexOf(placeholder);
        if (placeholder.localUrl) URL.revokeObjectURL(placeholder.localUrl);
        if (photoIndex !== -1) photos.splice(photoIndex, 1);
        renderPhotoSlots();
        photoStatus('Upload failed');
      });
  }

  function nextPhotoSlot(items, maxPhotos) {
    for (var slot = 0; slot < maxPhotos; slot++) {
      if (!items.some(function (p) { return p && p.slot === slot; })) return slot;
    }
    return -1;
  }

  function uploadedPhoto(data, slot) {
    var uploadedAssetId = typeof data.uploadedAssetId === 'string' ? data.uploadedAssetId.trim() : '';
    var assetId = typeof data.assetId === 'string' ? data.assetId.trim() : '';
    if (!uploadedAssetId && !assetId) return null;
    return {
      slot: slot,
      uploadedAssetId: uploadedAssetId,
      assetId: assetId,
      photoUrl: typeof data.photoUrl === 'string' ? data.photoUrl : '',
      thumbUrl: typeof data.thumbUrl === 'string' ? data.thumbUrl : '',
    };
  }

  function photosForSubmit(items) {
    return items.filter(function (p) {
      return p && !p.uploading && (p.uploadedAssetId || p.assetId);
    }).map(function (p) {
      var photo = { slot: p.slot };
      if (p.uploadedAssetId) photo.uploadedAssetId = p.uploadedAssetId;
      if (p.assetId) photo.assetId = p.assetId;
      if (p.photoUrl) photo.photoUrl = p.photoUrl;
      if (p.thumbUrl) photo.thumbUrl = p.thumbUrl;
      return photo;
    });
  }

  function removePhoto(idx) {
    invalidateSubmitAttempt();
    if (photos[idx]) {
      if (photos[idx].localUrl) URL.revokeObjectURL(photos[idx].localUrl);
    }
    photos.splice(idx, 1);
    renderPhotoSlots();
    photoStatus('');
  }

  function renderPhotoSlots() {
    var container = document.getElementById('pr-photo-slots');
    if (!container) return;
    container.innerHTML = '';

    photos.forEach(function (p, i) {
      var div = document.createElement('div');
      div.className = 'pr-photo-slot';
      var src = p.thumbUrl || p.localUrl || '';
      div.innerHTML = '<img class="pr-photo-preview" src="' + src + '" alt="">';
      if (p.uploading) {
        div.innerHTML += '<div class="pr-photo-uploading"><div class="pr-photo-spinner"></div></div>';
      } else {
        var rmBtn = document.createElement('button');
        rmBtn.type = 'button';
        rmBtn.className = 'pr-photo-remove';
        rmBtn.textContent = '\u00d7';
        rmBtn.addEventListener('click', function () { removePhoto(i); });
        div.appendChild(rmBtn);
      }
      container.appendChild(div);
    });

    if (photos.length < MAX_PHOTOS) {
      var addLabel = document.createElement('label');
      addLabel.className = 'pr-photo-add';
      addLabel.innerHTML = '<input type="file" accept="image/jpeg,image/png,image/webp" multiple style="display:none;"><span class="pr-photo-plus">+</span><span class="pr-photo-hint">Add photo</span>';
      addLabel.querySelector('input').addEventListener('change', function () {
        Array.from(this.files || []).forEach(function (f) { uploadPhoto(f); });
        this.value = '';
      });
      container.appendChild(addLabel);
    }
  }

  function photoStatus(t) {
    var el = document.getElementById('pr-photo-status');
    if (el) el.textContent = t || '';
  }

  // ── fullscreen carousel ────────────────────────────────────
  var fsOverlay = null, fsIdx = 0;

  function buildFsOverlay() {
    var d = document.createElement('div');
    d.className = 'pr-fs-overlay';
    d.innerHTML =
      '<button class="pr-fs-close" type="button">&times;</button>' +
      '<span class="pr-fs-counter"></span>' +
      '<button class="pr-fs-arrow pr-fs-prev" type="button">&#8249;</button>' +
      '<button class="pr-fs-arrow pr-fs-next" type="button">&#8250;</button>' +
      '<div class="pr-fs-track"></div>';
    document.body.appendChild(d);
    d.querySelector('.pr-fs-close').addEventListener('click', closeFs);
    d.querySelector('.pr-fs-prev').addEventListener('click', function () { navFs(-1); });
    d.querySelector('.pr-fs-next').addEventListener('click', function () { navFs(1); });
    d.addEventListener('click', function (e) { if (e.target === d) closeFs(); });

    // swipe
    var sx = 0, sy = 0;
    d.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    d.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) navFs(dx < 0 ? 1 : -1);
    });

    return d;
  }

  function openFs(idx) {
    if (!allReviews.length) return;
    if (!fsOverlay) fsOverlay = buildFsOverlay();
    fsIdx = idx;
    renderFsCard();
    fsOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', fsKey);
  }

  function closeFs() {
    if (fsOverlay) fsOverlay.classList.remove('open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', fsKey);
  }

  function fsKey(e) {
    if (e.key === 'Escape') closeFs();
    else if (e.key === 'ArrowLeft') navFs(-1);
    else if (e.key === 'ArrowRight') navFs(1);
  }

  function navFs(dir) {
    fsIdx = (fsIdx + dir + allReviews.length) % allReviews.length;
    renderFsCard();
  }

  function renderFsCard() {
    if (!fsOverlay) return;
    var r = allReviews[fsIdx];
    var track = fsOverlay.querySelector('.pr-fs-track');
    var counter = fsOverlay.querySelector('.pr-fs-counter');
    counter.textContent = (fsIdx + 1) + ' / ' + allReviews.length;

    var dt = r.createdAt ? new Date(r.createdAt).toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: 'numeric' }) : '';
    var edited = r.isEdited ? '<span class="pr-card-edited">edited</span>' : '';

    var tags = '';
    if ((r.effects && r.effects.length) || (r.flavorNotes && r.flavorNotes.length) || (r.bestFor && r.bestFor.length) || r.wouldBuyAgain === true) {
      tags = '<div class="pr-tags">';
      if (r.effects && r.effects.length) tags += tagGroup('Effects', r.effects);
      if (r.flavorNotes && r.flavorNotes.length) tags += tagGroup('Flavor', r.flavorNotes);
      if (r.bestFor && r.bestFor.length) tags += tagGroup('Best for', r.bestFor);
      if (r.wouldBuyAgain === true) tags += '<div class="pr-tag-group"><span class="pr-tag rc-would-buy-again">Would buy again</span></div>';
      tags += '</div>';
    }

    track.innerHTML =
      '<div class="pr-fs-card">' +
        '<div class="pr-card-meta"><div class="pr-card-who"><span class="pr-card-name">' + esc(r.authorFirstName) + '</span>' +
        (r.verified ? verifiedBadge() : '') +
        '</div><span class="pr-card-date">' + dt + ' ' + edited + '</span></div>' +
        '<div class="pr-card-stars">' + stars(r.rating) + '</div>' +
        (r.title ? '<p class="pr-card-title">' + esc(r.title) + '</p>' : '') +
        '<p class="pr-card-body">' + esc(r.body) + '</p>' +
        photosFull(r.photos) +
        tags +
      '</div>';

    // hide arrows if single review
    fsOverlay.querySelector('.pr-fs-prev').style.display = allReviews.length > 1 ? '' : 'none';
    fsOverlay.querySelector('.pr-fs-next').style.display = allReviews.length > 1 ? '' : 'none';
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
